import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography
} from "@mui/material";
import SmsButton from '../controls/SmsButton';
import ViberMessageButton from '../controls/ViberMessageButton';
import MessageIcon from '@mui/icons-material/Message';

function MessageNumberDialog({
  phoneNumber = "",
  bodyText = ''
}) {
  const [open, setOpen] = React.useState(false);

  const onCancel = () => {
    setOpen(false);
  };

  return (
    <>
    <Stack 
      direction="row" 
      spacing={1}
      sx={{ mb: 2 }}   // adds bottom margin
    >
      <Button
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<MessageIcon />}
        onClick={() => setOpen(true)}
      >
        Message
      </Button>
    </Stack>
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth disableRestoreFocus>
      <DialogTitle>Message {phoneNumber}</DialogTitle>
      <DialogContent>
        <Stack 
          direction="column" 
          spacing={1}
        >
          <SmsButton phoneNumber={phoneNumber} bodyText={bodyText} label={"SMS Text"} fullWidth={true} />
          <ViberMessageButton phoneNumber={phoneNumber} bodyText={bodyText} label={"Viber Message"} fullWidth={true} />
        </Stack>
        
      </DialogContent>
      <DialogActions>
        <>
          <div style={{flex: '1 0 0'}} />
          <Button onClick={onCancel} color="primary">
            Cancel
          </Button>
        </>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default MessageNumberDialog;